// Lib
import { produce } from 'immer';

// Constants
import { RESOURCES_FETCHED, ResourceTypes } from '../utils/services/http/asyncResource/asyncResourceConstants';
import { CmsEntities } from './cmsConstants';
import { AsyncResourceFetchedAction } from '../utils/services/http/asyncResource/asyncResourceActionsTypes';
import { CmsReducerState } from './cmsTypes';

// The rich media state is a map of ID to { contentState }
const initialState: CmsReducerState = {};

export default (state = initialState, action: AsyncResourceFetchedAction) => {
    const shouldLoadData = action.type === RESOURCES_FETCHED && action.resource === ResourceTypes.cms;

    if (!shouldLoadData) return state;

    const id = action.ids?.[0];
    const data = action.data;

    if (!id) return state;

    const resourceId = id as CmsEntities;

    return produce(state, (draft) => {
        draft[resourceId] = { data };
    });
};
